export class DownloadSuccessEffect {
  public static readonly type = '[Project/Storage/List] DownloadSuccessEffect';
}
